

const atualizarDrawer = ({ commit }, drawer) => {
    commit('atualizarDrawer', drawer);
}

export default {
    atualizarDrawer
}